module.exports = __webpack_public_path__ + "images/external_images/img/380x227/img7.jpg";